import styled from "styled-components";

export const AlertText = styled.div`
  gap: 28px;
  flex: 1;
  height: 100%;
  display: flex;
  align-items: center;
  flex-direction: column;
  justify-content: center;
`;

export const TextBox = styled.div`
  gap: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
`;

export const MainText = styled.p`
  color: ${(props) => props.theme.colors.text4};
  font-size: 1.5rem;
  font-weight: 700;
`;

export const SubText = styled.span`
  color: ${(props) => props.theme.colors.text2};
  display: flex;
  font-size: 1.3rem;
  text-align: center;
  align-items: center;
  line-height: 150%;
  justify-content: center;
`;

export const multipleBtnBox = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  gap: 8px;
`;
